import { Router } from "wouter";
import AdminApp from "./admin/AdminApp";
import "./App.css";
import { ConfigProvider } from "antd";
import { memo } from "react";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "rgb(4, 116, 184)",
          borderRadius: 2,
          // colorBgContainer: "#f6ffed",
        },
      }}
    >
      <div className="App">
        <Router>
          <AdminApp />
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default memo(App);
